class stockistFilters extends HTMLElement {
  constructor() {
    super();
    const inputs = [...new Set(
      Array.from(document.querySelectorAll(`[data-${this.dataset.type}]`))
        .map(el => 
          el.getAttribute(`data-${this.dataset.type}`)
        )
    )];

    this.createInputs(inputs, `[id=${this.dataset.type}Filter]`);

    this.inputs = this.querySelectorAll('input[type="checkbox"]');

    this.addEventListener('change', () => {
      // remove show more buttons and show all items before filtering
      if (document.querySelectorAll('.show-more-button')) {
        document.querySelectorAll('.show-more-button').forEach(el => el.remove());
        document.querySelectorAll('.stockists-collection__grid-item.hide').forEach(item => item.classList.toggle('hide'));
      }

      const checked = [...this.inputs].filter(el => el.checked).map(el => el.value);
      const elements = document.querySelectorAll(`[data-${this.dataset.type}]`);
      console.log(elements);
      if (checked.length > 0) {
        elements.forEach(el => {
          if (checked.includes(el.getAttribute(`data-${this.dataset.type}`))) {
            el.classList.remove('hide');
          } else {
            el.classList.add('hide');
          }
        });
      } else {
        elements.forEach(el => {
          el.classList.remove('hide');
        });

      }

      const collections = document.querySelectorAll('.stockists-collection');
      const allHidden = Array.from(collections).every(el => 
        window.getComputedStyle(el).display === 'none'
      );

      if (allHidden) {
        document.querySelector('.no-stockists-message').classList.remove('hide');
      } else {
        document.querySelector('.no-stockists-message').classList.add('hide');
      }
    });
  }

  createInputs(set, filter) {
    const filterEl = document.querySelector(filter);
    set.forEach(el => {
      // input creation
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.name = el;
      input.id = el;
      input.value = el;
      const label = document.createElement('label');
      label.htmlFor = el;
      filterEl.appendChild(label);
      label.innerText = el;
      label.appendChild(input);
      // custom checkmark
      const checkmark = document.createElement('span');
      checkmark.classList.add('checkmark');
      label.appendChild(checkmark);
    });
  }
}

export default stockistFilters;